import { IDemDatabaseSearchResult } from "../../services/middleware/mappers/searchDemandDevicesMapper"
import { IDeviceSearchResult } from "../../services/middleware/types/singleApplication/searchLctTypes"
import { IDatabaseSearchResult as IGenDatabaseSearchResult } from "../tables/ttr/genSearchResults"

/**
 * Maps a generation search result row into the {@link IDeviceSearchResult}
 * shape consumed by the application form / `SUPPLEMENTING_INFO_KW`.
 */
export const formatGenDeviceForApplication = (
    row: IGenDatabaseSearchResult
): IDeviceSearchResult => ({
    displayValue: `${row.manufacturer ?? ""} ${row.model ?? ""}`.trim(),
    deviceRef: row.deviceReference || "",
    deviceModelNo: row.model || "",
    deviceManufacturer: row.manufacturer || "",
    deviceSize: parseFloat(row.capacity) || 0,
    deviceSizeName: "Capacity",
    deviceSizeUnit: "kW",
    devicePhases: row.phases?.toString() || "",
})

/**
 * Maps a demand search result row into the {@link IDeviceSearchResult}
 * shape consumed by the application form / `SUPPLEMENTING_INFO_KW`.
 */
export const formatDemandDeviceForApplication = (
    row: IDemDatabaseSearchResult
): IDeviceSearchResult => ({
    displayValue: `${row.manufacturer ?? ""} ${row.modelRef ?? ""}`.trim(),
    deviceRef: row.deviceReference || "",
    deviceModelNo: row.modelRef || "",
    deviceManufacturer: row.manufacturer || "",
    deviceSize: Number(row.maxDemand) || 0,
    deviceSizeName: "Max Demand",
    deviceSizeUnit: "A",
    devicePhases: row.phases || "",
    v2gTtrStatus: row.v2gTtrStatus ?? null,
})
